module.exports = __webpack_public_path__ + "img/yan8.492df9b1.png";